const colAmount = 5;
export const gridCols = `grid-cols-${colAmount}`;
export const annualOnlyKey = "pricing_plans.annual_only";
